/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ users: NonNullable<unknown>, unit: NonNullable<unknown> }} Report_Basis_CopilotInputs */



/**
* | output |
* | --- |
* | "{users} users × {unit} per user" |
*
* @param {Report_Basis_CopilotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_basis_copilot = /** @type {((inputs: Report_Basis_CopilotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Basis_CopilotInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.users} Nutzer × ${i?.unit} pro Nutzer`)
	return /** @type {LocalizedString} */ (`${i?.users} users × ${i?.unit} per user`)
});